import type { IconName } from '#/components/Icon/IconName';

import type {
  PostOnIdealistDropdownResourcesItemData,
  PostOnIdealistDropdownSearchItemData,
} from './data/types/PostOnIdealistDropdownData';

export const postOnIdealistDropdownDataBySearchItemType: Record<
  PostOnIdealistDropdownSearchItemData['type'],
  { iconName: IconName; qaId: string; trackClickedName: string }
> = {
  'post-a-listing': {
    iconName: 'pin',
    qaId: 'nav-post-a-listing-link',
    trackClickedName: 'Post a Listing',
  },
  'create-org': {
    iconName: 'plus',
    qaId: 'nav-create-org-link',
    trackClickedName: 'Add your Organization',
  },
};

export const postOnIdealistDropdownDataByResourcesItemType: Record<
  PostOnIdealistDropdownResourcesItemData['type'],
  { image: string; imageHover: string; qaId: string; trackClickedName: string }
> = {
  funding: {
    image: 'illustrations/announce-illustration.svg',
    imageHover: 'illustrations/announce-illustration-hover.svg',
    qaId: 'nav-funding-resources-link',
    trackClickedName: 'Fundraising Resource',
  },
  'employer-resources': {
    image: 'illustrations/gear-illustration.svg',
    imageHover: 'illustrations/gear-illustration-hover.svg',
    qaId: 'nav-employer-resources-link',
    trackClickedName: 'Employer Resources',
  },
  'volunteer-resources': {
    image: 'illustrations/article-illustration.svg',
    imageHover: 'illustrations/article-illustration-hover.svg',
    qaId: 'nav-volunteer-engagement-resources-link',
    trackClickedName: 'Volunteer Resources',
  },
  'help-desk': {
    image: 'illustrations/talk-illustration.svg',
    imageHover: 'illustrations/talk-illustration-hover.svg',
    qaId: 'nav-help-desk-link',
    trackClickedName: 'Help Desk',
  },
};
